const data = {
  ErrorCard: {
    name: "관리자",
    tag: "관리자",
    mainText: "페이지를 찾을수 없어요! 😢",
    sideText:
      "주소의 입력이 잘못되었거나, 페이지의 주소가 변경 혹은 삭제되었을수 있어요. 다시 메인페이지에서 탐색하는게 어떨까요?",
    button: "메인페이지로 돌아가기",
  },

  DummyData1: {
    name: "테스트",
    tag: "테스트",
    sideText: "코로나가 또다시 기승을 부리는 요즘이네요. 건강, 체력 모두 조심하세요!",
  },
};

export default data;
